import $ from 'jquery';
import 'slick-carousel';

function Slider(element, settings) {
  this.$element = $(element);
  this.settings = settings;
  this.slider = this.build();
  this.ready();
}

Slider.prototype = {
  build() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Slider;



// WEBPACK FOOTER //
// ./Slider.js